/***
 * Created on 2023/8/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {getPrimaryEmail} from "../../../service/user";


function EmailSendDialog(props) {
    const { t } = useTranslation();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    return (
        <ModalDialog {...props} title={t('@Permanently Delete Account@')} hideCancel={true} submitAction={props.closeModal}>
            <div className="dialog-content">
                <p>{t('@An email requesting confirmation has been sent to@')}
                    <span className="display-inline-block font-medium pl-4 pr-4">{getPrimaryEmail(currentUser)}</span>
                </p>
                <p>{t('@Please check your email to confirm the deletion of myQNAPcloud account by clicking the provided link.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default EmailSendDialog;